module.exports = __webpack_public_path__ + "static/media/CO.3fee24bb.png";